export default {
  boolean: { 1: '是', 0: '否' },
  boolean2: { 0: '是', 1: '否' },
  has: { 0: '无', 1: '有' },
  isHidden: { 0: '启用', 1: '禁用' },
  isDisable: { 0: '启用', 1: '禁用' },
  isClose: { 1: '关闭', 0: '开启' },
  sex: { 0: '女', 1: '男' },
  subjectType: { 1: '自选', 2: '抽题' },
  screenStatus: { 2: '横屏', 1: '竖屏' },
  status: { 0: '待填写', 1: '待发布', 2: '已发布', 3: '已关闭' },
  categoryLevel: { 1: '一级分类', 2: '二级专业', 3: '三级级别' },
  payStatus: { 0: '未支付', 1: '已支付', 2: '已退款' },
  isPayed: { 0: '待付款', 1: '已付款' },
  isSuccess: { 0: '退款失败', 1: '退款成功' },
  isImport: { 0: '线上', 1: '导入' },
  enrollPayType: { 0: '导入(线下缴费)', 1: '导入(线上缴费)', 2: '线上' },
  auditStatus: { 1: '待审核', 2: '审核通过', 3: '审核未通过' },
  describeVerifyAuditStatus: { 2: '待审核', 3: '审核通过', 4: '审核未通过' },
  chooseQuestionStep: { 0: '报名时', 1: '考试时' },
  questionType: { 1: '模拟', 2: '正式' },
  newsType: { 0: '图文' },
  newsModule: { 0: '协会动态', 3: '考级资讯' },
  linkType: { 0: '文章', 1: '外链' },
  resetStatus: { 0: '已发送', 1: '重考中', 2: '已重考' },
  payType: { 0: '支付宝', 1: '微信' },
  officePayType: { 0: '线下缴费', 1: '线上缴费', 2: '审核缴费' },
  tradeState: { 0: '待支付', 1: '未支付', 2: '已支付', 3: '已取消', 4: '申请退款', 5: '已退款', 6: '退款失败' },
  idType: { '1': '身份证', '2': '港澳通行证', '3': '护照', '4': '台胞证' },
  smsType: { 0: '注册', 1: '找回密码', 2: '登录', 3: '修改账号' },
  dimensionType: { 0: '科目评分', 1: '综合评分', 2: '单维度评分' },
  dimensionType2: { 2: '单维度-多评委平均分' },
  evaluateType: { 0: '自定义设置', 1: '分值设置' },
  evaluateStatus: { 0: '未设置', 1: '已设置', 2: '评分中', 3: '已评分', 4: '已发布' },
  refundAuditStatus: { 1: '待审核', 2: '审核通过并退费', 3: '审核不通过' },
  evaluateStatus2: { 0: '未评分', 1: '评分中', 2: '已评分', 3: '已发布', 4: '缺考' },
  evaluateStatus3: { 0: '未打印', 2: '已打印' },
  isEvaluate: { 0: '未评审', 1: '已评审' },
  isPublish: { 0: '未发布', 1: '已发布' },
  examStatus: { 0: '未开始考试', 1: '未完成考试', 2: '考试中', 3: '已完成考试' },
  isOnline: { 0: '线下评分', 1: '线上评分' },
  countryCode: [{ code: "000000", desc: "国际" }, { code: "000001", desc: "中国" }, { code: "999999", desc: "港澳台侨" }],
  isLine: { 0: '线上和线下', 1: '线下', 2: '审核报名和线下' },
  isRepeat: { 0: '否', 1: '是' },
  system: { 0: '体制内', 1: '新文艺群体', 2: '空' },
  vipPayStatus: { 0: '已交终身会费', 1: '未交', 2: '高龄免缴' },
  infoStatus: { 0: '未更新', 1: '已更新', 2: '临时保存', 3: '失联', 4: '不配合', 5: '电话有误', 6: '出国定居' },
  currentStatus: { 0: '在职', 1: '离职退休', 2: '出国定居', 3: '失联', 4: '重疾', 5: '去世', 6: '退会', 7: '开除', 8: '空' },
  degree: { 0: '博士研究生', 1: '硕士研究生', 2: '大学', 3: '大专', 4: '高中', '5': '无' },
  politicalStatus: { 0: '中共', 1: '民革', 2: '民盟', 3: '民建', 4: '民进', 5: '农工', 6: '致公', 7: '九三学社', 8: '台盟', 9: '无党派', 10: '群众', 11: '空' },
  vipIdType: { 1: '身份证', 2: '港澳通行证', 3: '护照', 4: '军官证' },
  specialZhicheng: { 0: '正高', 1: '副高', 2: '中级', 3: '初级', 4: '无' },
  vipAuditStatus: { 0: '未提交申请', 1: '待审核', 2: '初审通过', 3: '初审未通过', 4: '终审通过', 5: '终审不通过' },
  vipAuditStatus1: { 1: '待审核', 2: '初审通过', 3: '初审未通过', 4: '终审通过', 5: '终审不通过' },
  vipAuditStatus2: { 1: '待审核', 2: '初审通过', 3: '初审未通过' },
  systemInfo: { 0: '体制内', 1: '新文艺群体', 2: '空' },
  nationality: { 0: '中国', 1: '国外' },
  professional: { 0: '创作', 1: '理论', 2: '表演', 3: '其他' },
  education: { 0: '博士研究生', 1: '硕士研究生', 2: '大学', 3: '大专', 4: '高中', 5: '无' },
  reviewStatus: { 0: '待审核', 1: '已审核' },
  authentication: { 0: '未认证', 1: '已认证' },
  sceneStatus: { 1: '完善信息并报名', 2: '完善信息', 3: '修改照片' },
  module: { 0: '平台管理', 1: '招考管理', 2: '资讯管理', 3: '考生管理', 4: '考试结果', 5: '人脸审核', 6: '审核管理', 7: '评分管理', 8: '会员管理', 9: '结算管理' },
  verifyStatus: { 0: '未处理', 1: '已通过', 2: '未通过' },
  pass: { 0: '大于等于', 1: '大于' },
  date: { 0: '天', 1: '周' },
  remarkTypeList: { 0: '优秀', 1: '良好', 2: '合格', 3: '不合格' },
  faceCompareStatus: { 1: '身份认证', 2: '实人认证' },
  isNewest: { 0: '待发布', 1: '待确认', 2: '已确认', 3: '已取消' },
  isSettle: { 0: '未结算', 1: '已结算' },
  remarkSortList: [
    {
      value: '1',
      label: '1'
    },
    {
      value: '2',
      label: '2'
    },
    {
      value: '3',
      label: '3'
    },
    {
      value: '4',
      label: '4'
    },
    {
      value: '5',
      label: '5'
    },
    {
      value: '6',
      label: '6'
    },
    {
      value: '7',
      label: '7'
    },
    {
      value: '8',
      label: '8'
    },
    {
      value: '9',
      label: '9'
    },
    {
      value: '10',
      label: '10'
    },
    {
      value: '11',
      label: '11'
    },
    {
      value: '12',
      label: '12'
    },
    {
      value: '13',
      label: '13'
    },
    {
      value: '14',
      label: '14'
    },
    {
      value: '15',
      label: '15'
    },
    {
      value: '16',
      label: '16'
    },
    {
      value: '17',
      label: '17'
    },
    {
      value: '18',
      label: '18'
    },
    {
      value: '19',
      label: '19'
    },
    {
      value: '20',
      label: '20'
    }
  ],
  remarkLevel: { 1: '不合格', 2: '合格', 3: '良好', 4: '优秀' },
  MusicbasisEvaluateStatus: { 0: '未评分', 1: '评分中', 2: '已评分', 3: '已发布' },
  resetStatus2: { 0: '全部', 1: '已发送', 2: '重考中', 3: '已重考' },
  paperTypes: { 0: '模拟', 1: '正式' },
  enrollStatus: { 1: '待发布', 2: '已发布', 3: '已关闭' },
  questionOptionsMappings: {
    1: 'A',
    2: 'B',
    3: 'C',
    4: 'D',
    5: 'E',
    6: 'F',
    7: 'G',
    8: 'H',
    9: 'I',
    10: 'J',
    11: 'K',
    12: 'L',
    13: 'M',
    14: 'N',
    15: '0',
    16: 'P',
    17: 'Q',
    18: 'R',
    19: 'S',
    20: 'T',
    21: 'U',
    22: 'V',
    23: 'W',
    24: 'X',
    25: 'Y',
    26: 'Z'
  },
  recordExamStatus: { 1: '考试未开始', 2: '考试未参加', 3: '考试中', 4: '考试未完成', 5: '考试已完成' },
  isChoiceScene: { 0: '待预约', 1: '已重置', 2: '已预约' },
  settleStatus: {
    1: '结算中',
    2: '已结算',
    3: '已取消'
  },
  incomeStatus: { 0: '未结算', 1: '已结算' },
  hasMonitorCommit: { 0: '无', 1: '有' },
  IsSolve: { 1: '未审核', 2: '已审核' },
  examinerStatus: { 0: '待发布', 1: '已发布' },
  applyState: {  1: '待初审', 2: '初审通过待终审', 3: '初审不通过', 4: '终审通过', 5: '终审不通过' },
  examinerType: { 1: '校内考官', 2: '成都市内校外考官', 3: '四川省地市州校外考官', 4: '四川省外校外考官' },
  examinerNature: { 0: '无', 1: '在编', 2: '人事代理', 3: '聘用', 4: '退休返聘' },
  academicDegree: { 0: '无', 1: '学士学位', 2: '硕士学位', 3: '博士学位' },
  professionalTitle: { 0: '无', 1: '助教', 2: '讲师', 3: '副教授', 4: '教授',  5: '其他(初级)', 6: '其他(中级)', 7: '其他(副高)', 8: '其他(正高)' },
  idType2: { 0: '身份证', 1: '护照' },
  education2: { 0: '无', 1: '初中', 2: '高中(中职)', 3: '大学专科(高职)', 4: '大学本科',  5: '硕士研究生', 6: '博士研究生' },
  auditStatus2: { 2: '待审核', 3: '审核通过', 4: '审核不通过' },
  enrollPayType2: { 3: '导入', 4: '在线(审核报名)' },
  enrollPayType3: { 0: '导入(线下缴费)', 1: '导入(线上缴费)', 2: '线上(缴费报名)', 3: '导入(审核缴费)', 4: '线上(审核报名)' },
  isExotic:  { 0: '线上评分', 1: '线下导入' }
}
